module.exports = __webpack_public_path__ + "img/Help.6439309b.svg";